import React from 'react';
import Button from '../components/Button';
import Card from '../components/Card';
import CustomerCard from '../components/CustomerCard';
import LabelText from '../components/LabelText';
import Layout from '../components/layout/Layout';
import SplitSection from '../components/SplitSection';
import StatsBox from '../components/StatsBox';
import customerData from '../data/customer-data';
import HeroImage from '../svg/HeroImage';
import SvgCharts from '../svg/SvgCharts';


const membershipForm = "https://storage.googleapis.com/alimanassets/sisbc/Funeral_services_membership_form_September_2025.pdf";
const burial_policy = "https://storage.googleapis.com/alimanassets/sisbc/Burial_Policy_September_2025.pdf";

const MemberTemplate = (data) => {
  const { memberList, sectionId, sectionTitle } = data;
  return (
    <section id={sectionId} className="py-20 lg:pb-20">
      <div className="container mx-auto text-center">
        <h2 className="text-3xl lg:text-5xl font-semibold">{sectionTitle}</h2>
        <div className="flex flex-wrap -mx-4 overflow-hidden sm:-mx-2 xl:-mx-3">
          {memberList.map((person, index) => (
            <div
              key={index}
              className="my-4 px-4 w-full overflow-hidden sm:my-2 sm:px-2 sm:w-1/2 md:w-1/3 xl:my-3 xl:px-3"
            >
              <Card className="mb-8">
                <p className="font-semibold text-xl">{person.name}</p>
                <p className="mt-4">{person.position}</p>
              </Card>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const Index = () => (
  <Layout>
    <section className="pt-20 md:pt-40">
      <div className="container mx-auto px-8 lg:flex">
        <div className="text-left">
          <h1 className="text-2xl font-bold">
            Islamic Burial Costs — Metro Vancouver
          </h1>
          <div className='mt-8 text-xl pt'>
            Death is an inevitable and unpredictable part of life. None of us knows when or where it will occur. It is therefore incumbent upon every member of the SOM community to be prepared to leave this world for our permanent home.
          </div>

          <div className='mt-8 text-xl pt'>
            Funeral services in this region are often expensive and complicated. The following are the Islamic burial costs required for every deceased person in Metro Vancouver:
          </div>

          <ul className='mt-8 text-xl list-disc pl-6'>
            <li>Grave cost: $2,000</li>
            <li>Administrative and legal documentation</li>
            <li>Transportation of the deceased from the holding facility to the mosque for Ghusl and Janazah, then to the cemetery: $1,500</li>
            <li>Opening and closing of the grave: $5,500</li>
            <li>Headstone / grave marker: $2,000</li>
          </ul>

          <div className='mt-8 text-xl pt'>
            This project is for the Somali Community in Metro-Vancouver, British Columbia. Its aim is to collectively cover funeral costs and ensure timely,
            dignified burials that follow Islamic guidelines.
          </div>
          <p className="mt-8 md:mt-12">
            <button
              type="button"
              className={`
                py-4 px-12
                bg-primary
                hover:bg-primary-darker
                rounded
                text-white
            `}
              onClick={() => { window.location.assign(membershipForm); }}
            >
              Download Funeral Services Membership Form
            </button>
          </p>

        </div>
      </div>

    </section>
    <section className="pt-20">
      <div className="container mx-auto px-8 lg:flex">
        <button
          type="button"
          className={`
                py-4 px-12
                bg-primary
                hover:bg-primary-darker
                rounded
                text-white
            `}
          onClick={() => { window.location.assign(burial_policy); }}
        >
          Funeral Services Policy
        </button>


      </div>


    </section>


    {/* <SplitSection
      id="services"
      primarySlot={
        // <div className="lg:pr-32 xl:pr-48">
        //   <h3 className="text-3xl font-semibold leading-tight">Board of Trustees</h3>
        //   <p className="mt-8 text-xl font-light leading-relaxed">
        //    List of candidates
        //   </p>
        // </div>
        <div>
              <MemberTemplate memberList={currentMembers} sectionId={'features'} sectionTitle={'Board Members'}/>
        </div>
      }
    /> */}
    {/* <SplitSection
      reverseOrder
      primarySlot={
        <div className="lg:pl-32 xl:pl-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Design And Plan Your Business Growth Steps
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            Once the market analysis process is completed our staff will search for opportunities
            that are in reach
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    /> */}
    {/* <SplitSection
      primarySlot={
        <div className="lg:pr-32 xl:pr-48">
          <h3 className="text-3xl font-semibold leading-tight">
            Search For Performance Optimization
          </h3>
          <p className="mt-8 text-xl font-light leading-relaxed">
            With all the information in place you will be presented with an action plan that your
            company needs to follow
          </p>
        </div>
      }
      secondarySlot={<SvgCharts />}
    /> */}
    {/* <section id="stats" className="py-20 lg:pt-32">
      <div className="container mx-auto text-center">
        <LabelText className="text-gray-600">Our customers get results</LabelText>
        <div className="flex flex-col sm:flex-row mt-8 lg:px-24">
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+100%" secondaryText="Stats Information" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+100%" secondaryText="Stats Information" />
          </div>
          <div className="w-full sm:w-1/3">
            <StatsBox primaryText="+100%" secondaryText="Stats Information" />
          </div>
        </div>
      </div>
    </section> */}
    {/* <section id="testimonials" className="py-20 lg:py-40">
      <div className="container mx-auto">
        <LabelText className="mb-8 text-gray-600 text-center">What customers are saying</LabelText>
        <div className="flex flex-col md:flex-row md:-mx-3">
          {customerData.map((customer) => (
            <div key={customer.customerName} className="flex-1 px-3">
              <CustomerCard customer={customer} />
            </div>
          ))}
        </div>
      </div>
    </section> */}
    <section className="container mx-auto my-20 py-24 bg-gray-200 rounded-lg text-center">
      <h3 className="text-5xl font-semibold">Ready to become a SISBC member?</h3>
      {/* <p className="mt-8 text-xl font-light">
        Quis lectus nulla at volutpat diam ut. Enim lobortis scelerisque fermentum dui faucibus in.
      </p> */}
      <p className="mt-8">
        <Button size="xl">Become a SISBC Member</Button>
      </p>
    </section>
  </Layout>
);

export default Index;
